import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { VNode } from 'vue'
import type { AutoLinkConfig } from 'vuepress/client'
import { AutoLink } from 'vuepress/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPAutoLink',
  props: {
    config: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AutoLink), { config: _ctx.config }, _createSlots({
    before: _withCtx(() => [
      _renderSlot(_ctx.$slots, "before", _normalizeProps(_guardReactiveProps(_ctx.config)))
    ]),
    after: _withCtx(() => [
      _renderSlot(_ctx.$slots, "after", _normalizeProps(_guardReactiveProps(_ctx.config)))
    ]),
    _: 2
  }, [
    (_ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.config)))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["config"]))
}
}

})